import ForgotPass from '../pages/frontend/ForgotPassword';
import ResetPass from '../pages/frontend/ResetPassword';
import Login from '../pages/frontend/Login';


const FrontendRoute = [
    { path: '/', name: 'Home', component: <Login /> },
    { path: '/login', name: 'Login', component: <Login /> },
    { path: '/reset-password', name: 'Signup', component: <ResetPass /> },
    { path: '/forgot-password', name: 'Signup', component: <ForgotPass /> },
];

export default FrontendRoute;